import React, { useEffect } from "react";
import { connect } from "react-redux";
import Footer from "../Footer/Footer";
import styled from "styled-components";
import HeaderNavImproved from "../Nav/HeaderNavImproved/HeaderNavImproved.tsx";
import NewNavImproved from "../Nav/NewNavImproved/NewNavImproved.tsx";
import FloatingAgent from "../FloatingAgent/FloatingAgent.tsx";
import { useLocation } from "react-router-dom";
import { useNavVisibility } from "../../hooks/useNavVisibility.ts";
import { viewAccessRequest } from "../../store/actions";

const ContainerBig = styled.main`
  display: flex;
  position: relative;
  justify-content: flex-start;
  background-color: #f8fafc;
  height: 100%;
  min-height: 100vh;
  width: 100%;
`;

const SidebarColumn = styled.aside`
  flex-shrink: 0;

  @media (max-width: 900px) {
    display: none;
  }
`;

const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const Container = styled.main`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-top: 60px;
  --layout-header-offset: 60px;
  min-height: calc(100vh - var(--layout-header-offset, 60px));

  @media (max-width: 900px) {
    margin-top: 0px;
    --layout-header-offset: 0px;
  }
`;

const Content = styled.main`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  ${(props) => (props.isDashboard ? "min-height: 85vh;" : "")}
  @media (max-width: 480px) {
    padding: 0;
    height: 100%;
  }
`;

const Layout = ({ children, viewAccessRequest }) => {
  const { ocultarEnMobile } = useNavVisibility();
  const location = useLocation();

  const isDashboard = location.pathname === "/dashboard";
  const showSidebar = !isDashboard && !ocultarEnMobile;

  useEffect(() => {
    viewAccessRequest();
  }, [viewAccessRequest]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <ContainerBig>
      {showSidebar && (
        <SidebarColumn>
          <NewNavImproved />
        </SidebarColumn>
      )}
      <MainColumn>
        {!ocultarEnMobile && (
          <HeaderNavImproved />
        )}
        <Container>
          <Content isDashboard={isDashboard}>
            {children}
          </Content>
          {isDashboard && <Footer />}
        </Container>
        <FloatingAgent />
      </MainColumn>
    </ContainerBig>
  );
};

export default connect(null, { viewAccessRequest })(Layout);
